export default "__VITE_ASSET__yNQ2VWws__"